<template>
  <div>
    <BContainer>
      <div class="columns">
        <div class="column">
          <b-field grouped group-multiline>
            <a class="button is-primary" @click="openEditModal(null)">{{ $t('button.new') }}</a>
          </b-field>
        </div>
        <div class="column is-4" v-if="role.admin">
          <b-field>
            <b-select expanded v-model="selectedCompanyId" name="company" @input="onChangeCompany">
              <option :value="null">-- {{ $t('title.onlineInternalAuditProcesses') }} --</option>
              <option v-for="option in mainCompanies" :value="option.id" :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <b-table :data="filteredProcesses" :striped="true" :hoverable="true" :mobile-cards="true">
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" numeric :visible="false">
            {{ props.row.id }}
          </b-table-column>
          <b-table-column
            v-if="isProcessGroup || role.admin"
            field="processGroup"
            :label="$t('title.parentDepartment')"
            >{{
              props.row.processGroup ? props.row.processGroup.parentProcessGroup.name : ''
            }}
          </b-table-column>
          <b-table-column
            v-if="isProcessGroup || role.admin"
            field="processGroup"
            :label="$t('title.department')"
            >{{ props.row.processGroup ? props.row.processGroup.name : '' }}
            </b-table-column>
          <b-table-column field="name" :label="$t('validation.attributes.name')">{{
            props.row.name
          }}</b-table-column>
          <b-table-column
            v-if="!isProcessGroup"
            field="financialReport"
            :label="$t('title.financialReport')"
            numeric
          >
            {{ props.row.financialReport }}
          </b-table-column>
          <b-table-column
            v-if="!isProcessGroup"
            field="adaptation"
            :label="$t('title.adaptation')"
            numeric
          >
            {{ props.row.adaptation }}
          </b-table-column>
          <b-table-column
            v-if="!isProcessGroup"
            field="operation"
            :label="$t('title.operation')"
            numeric
          >
            {{ props.row.operation }}
          </b-table-column>
          <b-table-column v-if="!isProcessGroup" field="abuse" :label="$t('title.abuse')" numeric>{{
            props.row.abuse
          }}</b-table-column>
          <b-table-column
            v-if="isProcessGroup || role.admin"
            field="weightForPoint"
            :label="$t('title.weight')"
            numeric
            >{{ props.row.weightForPoint }}</b-table-column
          >
          <b-table-column>
            <div class="buttons">
              <b-button icon-right="edit" @click="openEditModal(props.row.id)" />
              <b-button icon-right="trash-alt" @click="deleteProcess(props.row.id)" />
              <router-link
                :to="{ name: 'adminProcessQuestion', params: { processId: props.row.id } }"
              >
                <b-button icon-right="list-ul" />
              </router-link>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </BContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../_api/api.service'
import ProcessEdit from './ProcessEdit.vue'

export default {
  data () {
    return {
      processes: [],
      filteredProcesses: [],
      mainCompanies: [],
      selectedCompanyId: null
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'role']),
    isProcessGroup () {
      return this.role.processWithPoint && this.currentUser.companyId
    }
  },
  mounted () {
    this.getProcesses()
    if (this.role.admin) {
      this.getMainCompanies()
    }
  },
  methods: {
    getProcesses () {
      ApiService.query('/process/admin').then(data => {
        this.processes = data
        if (this.role.admin) {
          this.filteredProcesses = data.filter(d => d.parentCompanyId === this.selectedCompanyId)
        } else {
          this.filteredProcesses = data
        }
      })
    },
    getMainCompanies () {
      ApiService.query('/select/maincompanies').then(data => {
        this.mainCompanies = data
      })
    },
    onChangeCompany (companyId) {
      this.filteredProcesses = this.processes.filter(p => p.parentCompanyId === companyId)
    },
    openEditModal (processId) {
      this.$buefy.modal.open({
        parent: this,
        props: { processId },
        component: ProcessEdit,
        events: {
          saved: () => {
            this.getProcesses()
          }
        }
      })
    },
    deleteProcess (processId) {
      this.$buefy.dialog.confirm({
        title: this.$t('title.deletingProcess'),
        message: this.$t('description.deletingProcessConfirmMessage'),
        confirmText: this.$t('button.deleteProcess'),
        cancelText: this.$t('button.cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          ApiService.delete('/process', { data: { processId } }).then(isDeleted => {
            if (isDeleted) {
              this.processes = this.processes.filter(p => p.id !== processId)
              if (this.role.admin) {
                this.filteredProcesses = this.processes.filter(
                  p => p.parentCompanyId === this.selectedCompanyId
                )
              } else {
                this.filteredProcesses = [...this.processes]
              }
            } else {
              this.deleteProcess(processId)
            }
          })
        }
      })
    }
  }
}
</script>
